module.exports = __webpack_public_path__ + "img/park-live-second-block-img-mobile.f1ff17b0.png";